




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GetTooDetail } from '../../api/common/index';
import { downloadByUrl } from '@/utils/file.util';

@Component({
  components: {},
})
export default class Index extends Vue {
  data = {} as any;
  showChoose = false;
  currentIndex = 0;
  mounted() {
    this.getDetail();
  }

  async getDetail() {
    await GetTooDetail({ toolCode: this.$route.query.code }).then(res => {
      this.data = res;
    });
  }

  service() {
    window.open(this.data.description.jumpUrl, '_blank');
  }

  download() {
    downloadByUrl(this.data.description.downloadUrl, this.data.name);
  }

  handleDownload(index: number, url: string) {
    this.currentIndex = index;
    this.showChoose = false;
    downloadByUrl(url, this.data.name);
  }
}
